import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "expandButton", "collapseButton"]

  connect() {
    // Solo aplicar comportamiento de collapse en móviles
    if (this.isMobile()) {
      this.isExpanded = false
      this.collapse()
    } else {
      // En desktop, asegurarse de que el panel esté visible
      this.panelTarget.style.maxHeight = ""
      this.panelTarget.style.opacity = ""
      this.panelTarget.style.transform = ""
    }
  }

  toggle() {
    // Solo permitir toggle en móviles
    if (!this.isMobile()) return

    if (this.isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    // Feedback háptico
    if (navigator.vibrate) {
      navigator.vibrate(5)
    }

    // Expandir el panel con efecto persiana desde arriba
    this.panelTarget.style.maxHeight = "calc(100vh - 45px)"
    this.panelTarget.style.opacity = "1"
    this.panelTarget.style.transform = "translateY(0)"
    
    // Rotar el ícono chevron hacia arriba
    if (this.hasExpandButtonTarget) {
      const icon = this.expandButtonTarget.querySelector('svg')
      if (icon) {
        icon.style.transform = "rotate(180deg)"
      }
    }
    
    this.isExpanded = true
  }

  collapse() {
    // Colapsar el panel con efecto persiana hacia arriba
    this.panelTarget.style.maxHeight = "0"
    this.panelTarget.style.opacity = "0"
    this.panelTarget.style.transform = "translateY(-1rem)"
    
    // Restaurar rotación del ícono chevron hacia abajo
    if (this.hasExpandButtonTarget) {
      const icon = this.expandButtonTarget.querySelector('svg')
      if (icon) {
        icon.style.transform = "rotate(0deg)"
      }
    }
    
    this.isExpanded = false
  }

  isMobile() {
    return window.innerWidth < 768
  }
}
